/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

// Most recent timer first. Falls back through the available timestamps so paused
// timers (without `started_at`) are still ordered consistently.
const recencyKey = (item: Record<string, any>): number => {
  const value = item?.created_at ?? item?.started_at ?? item?.date;
  return value ? new Date(value).getTime() : 0;
};

const sortByMostRecent = (items: Record<string, any>[] | null | undefined): Record<string, any>[] =>
  [...(items ?? [])].sort((a, b) => recencyKey(b) - recencyKey(a));

export const activeLogsSlice = createSlice({
  name: 'activeLogs',
  initialState: {
    loading: false,
    data: null as Record<string, any>[] | null,
    activeData: null as Record<string, any> | null,
  },
  reducers: {
    getActiveLogs: () => {},
    getActiveLogsSilent: () => {},
    setActiveLogsLoading: (state) => ({ ...state, loading: true, error: null }),
    setActiveLogsData: (state, action) => ({ ...state, loading: false, data: sortByMostRecent(action.payload) }),
    addActiveLogData: (state, action) => ({ ...state, data: sortByMostRecent([...(state.data ?? []), action.payload]) }),
    updateActiveLogData: (state, action) => ({
      ...state,
      data: state.data
        ? sortByMostRecent(state.data.map((item) => (item.uuid === action.payload.uuid ? action.payload : item)))
        : null,
    }),
    removeActiveLogData: (state, action) => ({
      ...state,
      data: state.data?.filter((item) => item.uuid !== action.payload) ?? null,
    }),
    setActiveLogsError: (state, action) => ({ ...state, loading: false, error: action.payload }),
    setActiveLogsActiveData: (state, action) => ({ ...state, activeData: action.payload }),
  },
});

export const {
  setActiveLogsData,
  addActiveLogData,
  updateActiveLogData,
  removeActiveLogData,
  setActiveLogsActiveData,
  setActiveLogsError,
  setActiveLogsLoading,
  getActiveLogs,
  getActiveLogsSilent,
} = activeLogsSlice.actions;

export default activeLogsSlice.reducer;
